export const ADE_CADASTRE_MULTIPART_REPAIR_POLICY_V1 = {
    contractVersion: "ade-cadastre-multipart-repair-policy/v1",
    mappingVersion: "ade-cadastre/v3",
    sourceKey: "ade.cadastral-cartography",
    sourceArtifactSha256: "0e4caefb1080fe25e94e1ccca0de2d20cb0303b151ada1813152c2cbd61ba795",
    entries: [
        {
            artifactKey: "ade-cadastre-rer-regional-bulk",
            layerKey: "CADASTRAL_PARCEL",
            externalIdSha256: "42886b6a539bdba9a19d799b5135a1c741e22852e3e97a27ce372015aa4998f1",
            logicalSourceSha256: "ac37f48df227df8799b7fd0e0f6038f428cd4a2b63f213aeb9fa53c94f00dcbe",
            cardinality: 6,
            unionGeometrySha256: "c1a9da456d529f1e5d902c6b9e8fc314a3ff3f5e2f8c675909ef542cabc5a049",
            overlapEvidence: {
                overlappingPairCount: 1,
                overlapArea: 1.934184573165439e-13,
                unionArea: 0.0000014892078075232117,
                overlapRatio: 1.2988009889514977e-7,
                maximumPairOverlapArea: 1.9341845704044914e-13,
                maximumPairOverlapRatio: 0.000010962711245868881
            },
            occurrences: [
                {
                    locator: {
                        archivePath: "FO.zip!/C573_CESENA.zip!/C573_CESENA_ple.gml",
                        gmlMember: 91_286
                    },
                    canonicalContentHash: "ec2f919aca03bce3816d1fdab8de7329301441ed3ce35ce3472d949d33c5ef8f",
                    sourceGeometrySha256: "38fc422ba074125b4a4d95de50dc7ee16563f92707556a15b0d32dfd6dbd122d"
                },
                {
                    locator: {
                        archivePath: "FO.zip!/C573_CESENA.zip!/C573_CESENA_ple.gml",
                        gmlMember: 91_287
                    },
                    canonicalContentHash: "ab5d12fdefa3378e7c1ff0f9f9c4ec9b31a91dabca84fe242cc9401752a12bd4",
                    sourceGeometrySha256: "52985e1af263796cd1e511e05f8a779256b736d34bf43174964f49156d38d78d"
                },
                {
                    locator: {
                        archivePath: "FO.zip!/C573_CESENA.zip!/C573_CESENA_ple.gml",
                        gmlMember: 91_288
                    },
                    canonicalContentHash: "25542de078c25937f8af604c571ec7282403df2ee0432abc3cf935eb93e7ab0e",
                    sourceGeometrySha256: "a66c2d527b8d2a5d2a60b105edd797d7ffac77b41b082bdab0d94317e637fa5a"
                },
                {
                    locator: {
                        archivePath: "FO.zip!/C573_CESENA.zip!/C573_CESENA_ple.gml",
                        gmlMember: 91_289
                    },
                    canonicalContentHash: "78e9e87a5c944469725a4c96a7e3092744ab6219166ba6419b67df81bd99082d",
                    sourceGeometrySha256: "3c9146508bacfabacff4f1753f431bb3f0876a23d007566dc2f87cc087809fab"
                },
                {
                    locator: {
                        archivePath: "FO.zip!/C573_CESENA.zip!/C573_CESENA_ple.gml",
                        gmlMember: 91_290
                    },
                    canonicalContentHash: "c721b315425a3d7bce6ed8daf3761e8755de32de42987cde252fdaac6446eeca",
                    sourceGeometrySha256: "48271a34569649c4739dd8b48acdbe8fda559b21058f013080ef98d77285846a"
                },
                {
                    locator: {
                        archivePath: "FO.zip!/C573_CESENA.zip!/C573_CESENA_ple.gml",
                        gmlMember: 91_291
                    },
                    canonicalContentHash: "4c4da15bacf0a89445d58e03013054de7e24e8f86a81029001e35632982386e6",
                    sourceGeometrySha256: "710717c9f7da8e32e38c140b07350b87a37f79c5d754a7237c152df774e50b94"
                }
            ]
        },
        {
            artifactKey: "ade-cadastre-rer-regional-bulk",
            layerKey: "CADASTRAL_PARCEL",
            externalIdSha256: "860a1687e87907748b8910ca442b1b0e029213de6055615b0517e69f37138886",
            logicalSourceSha256: "ac37f48df227df8799b7fd0e0f6038f428cd4a2b63f213aeb9fa53c94f00dcbe",
            cardinality: 9,
            unionGeometrySha256: "8a4bd29f61572361874d0db1846ad4dcd007cdcfe1a4ff7815f7daa69ae6c2a7",
            overlapEvidence: {
                overlappingPairCount: 2,
                overlapArea: 2.720552578586188e-12,
                unionArea: 0.0000048907662715587995,
                overlapRatio: 5.562630531757318e-7,
                maximumPairOverlapArea: 2.5690551441274328e-12,
                maximumPairOverlapRatio: 0.000042551953746623324
            },
            occurrences: [
                {
                    locator: {
                        archivePath: "FO.zip!/C573_CESENA.zip!/C573_CESENA_ple.gml",
                        gmlMember: 91_553
                    },
                    canonicalContentHash: "0c479ab02d088aa8dfe5ee9e51a60f00f33c257fb23b89b6cefafccb1723b338",
                    sourceGeometrySha256: "bbfc9ca583dd207d7db14d42d3603c2b84199bb0f3e792e579b7b555a1447250"
                },
                {
                    locator: {
                        archivePath: "FO.zip!/C573_CESENA.zip!/C573_CESENA_ple.gml",
                        gmlMember: 91_554
                    },
                    canonicalContentHash: "3b82e78617dc898d33b61c2518397349d8330f36102dcec3742b85813ddbe2ff",
                    sourceGeometrySha256: "0329ed68cf522ac7c75665147dff7c19d2da1df54c5b8c90047b5868e37738a1"
                },
                {
                    locator: {
                        archivePath: "FO.zip!/C573_CESENA.zip!/C573_CESENA_ple.gml",
                        gmlMember: 91_555
                    },
                    canonicalContentHash: "3849452843946bfed3fb70635d5398a9d9ea826af597a66955da978cc86b3c3e",
                    sourceGeometrySha256: "1e0024aca0725967f36f31e06c6ffb1eb54bea7d0505fc807a36dfbc0ced06ee"
                },
                {
                    locator: {
                        archivePath: "FO.zip!/C573_CESENA.zip!/C573_CESENA_ple.gml",
                        gmlMember: 91_556
                    },
                    canonicalContentHash: "2ad246e2aaafe723f3f96d8dd9c7409a5806fab0666031e0ea6a82e82367d75d",
                    sourceGeometrySha256: "6420dd0e90832f55711e239b41290d5eb24150c936628f8db3b9e3e8d1b96982"
                },
                {
                    locator: {
                        archivePath: "FO.zip!/C573_CESENA.zip!/C573_CESENA_ple.gml",
                        gmlMember: 91_557
                    },
                    canonicalContentHash: "603f2a0c3dd3029c4eca00ab2e4f8dd44f24d3955cecd18d8dafa8bf1ff860e7",
                    sourceGeometrySha256: "b2cc7780f22d5896dd2dc8e9dca8034aabe0c5836e5f9d2cd0722651cdbe9e60"
                },
                {
                    locator: {
                        archivePath: "FO.zip!/C573_CESENA.zip!/C573_CESENA_ple.gml",
                        gmlMember: 91_558
                    },
                    canonicalContentHash: "a7fd5a9acf08c45204a895e5a23de87e78593759da81adf3288e451be87cc329",
                    sourceGeometrySha256: "870120cfd6bd76a81d86737dd2814f53594721f6c10048296e6e88550ffe672e"
                },
                {
                    locator: {
                        archivePath: "FO.zip!/C573_CESENA.zip!/C573_CESENA_ple.gml",
                        gmlMember: 91_559
                    },
                    canonicalContentHash: "0c21b9d931bff44aa2110cdff92146c08449b10a45f84706d0d6f804d568dcc4",
                    sourceGeometrySha256: "2344e5c1d61b6a03888549dc1f63f54094065a6c3d5d5d9ad5b247b83d298fe7"
                },
                {
                    locator: {
                        archivePath: "FO.zip!/C573_CESENA.zip!/C573_CESENA_ple.gml",
                        gmlMember: 91_560
                    },
                    canonicalContentHash: "7ecae1e75cc7201b259d43ef9002a2f78a997ba8e2bd5698ffd5e87933d38a39",
                    sourceGeometrySha256: "d7e5e5f6e3627522bdf90f80e3b47332385241cc0e978b8f7773092fba090dd4"
                },
                {
                    locator: {
                        archivePath: "FO.zip!/C573_CESENA.zip!/C573_CESENA_ple.gml",
                        gmlMember: 91_561
                    },
                    canonicalContentHash: "9f0caff17177fd5c43e024039f47d8c9c7724963999480b81a5d8be2eccb0ac6",
                    sourceGeometrySha256: "198360dc66a94111aa01e65902b82e599a692adae863f03d5fec6281ba5db10e"
                }
            ]
        },
        {
            artifactKey: "ade-cadastre-rer-regional-bulk",
            layerKey: "CADASTRAL_PARCEL",
            externalIdSha256: "67e6988af170056399d44456a850f0c91928f396acce24c2d7b5047292d956e5",
            logicalSourceSha256: "30c5a691fceb79e4e1745b5be6df3d325d2680144a9e32c2e4bcd5b8e024e67e",
            cardinality: 2,
            unionGeometrySha256: "03a459727c4202907f1dc74b3420343b9dac2e4705060e8f16bbb11ad9bcd7e7",
            overlapEvidence: {
                overlappingPairCount: 1,
                overlapArea: 1.4964935537374038e-15,
                unionArea: 5.537739860544889e-7,
                overlapRatio: 2.7023543745699815e-9,
                maximumPairOverlapArea: 1.4966949433353908e-15,
                maximumPairOverlapRatio: 0.000030240385200022404
            },
            occurrences: [
                {
                    locator: {
                        archivePath: "BO.zip!/I191_SANT`AGATA BOLOGNESE.zip!/I191_SANT`AGATA BOLOGNESE_ple.gml",
                        gmlMember: 3_221
                    },
                    canonicalContentHash: "6837f309a024cea183db581c2609708e3d5c253c8152ee7d546b0595391bdfff",
                    sourceGeometrySha256: "d7ac35de5a034753d1932b1fc84f8b1329e48ad10534222fef84c21fa5a35eb4"
                },
                {
                    locator: {
                        archivePath: "BO.zip!/I191_SANT`AGATA BOLOGNESE.zip!/I191_SANT`AGATA BOLOGNESE_ple.gml",
                        gmlMember: 3_222
                    },
                    canonicalContentHash: "0e4a745c1e0436545a97a1e80472671524667beccecc190b4b3d49a6ed0cf0cd",
                    sourceGeometrySha256: "bb13a24949fc0187f644db1aeedfc81d608afc8ae54cb619bda0a514dce5a96e"
                }
            ]
        },
        {
            artifactKey: "ade-cadastre-rer-regional-bulk",
            layerKey: "CADASTRAL_PARCEL",
            externalIdSha256: "d123fbd60d32ef8aea269d91530d8be026a04418250883d86790e3e4f34f2d93",
            logicalSourceSha256: "90b1d304530885986cb6716aead301deda26772f112f8a50e2321e4efea6cba6",
            cardinality: 2,
            unionGeometrySha256: "244a11e2ca54b7f4edbc6963c5bd7ac85a32df814a0d50d6030e45be48010fce",
            overlapEvidence: {
                overlappingPairCount: 1,
                overlapArea: 4.390263181649871e-14,
                unionArea: 0.0000013294160464439703,
                overlapRatio: 3.30239972158701e-8,
                maximumPairOverlapArea: 4.390235408766475e-14,
                maximumPairOverlapRatio: 0.0002756421623977735
            },
            occurrences: [
                {
                    locator: {
                        archivePath: "FO.zip!/L764_VERGHERETO.zip!/L764_VERGHERETO_ple.gml",
                        gmlMember: 7_014
                    },
                    canonicalContentHash: "a0320291a06f2edb2786e75148fdc4e2f25cb66609ac1bc9a544d29ce17f79f3",
                    sourceGeometrySha256: "aadab9d20272f160bcc5189b4c8dd479c217424914cc2f3bdd43a4736cb8bb72"
                },
                {
                    locator: {
                        archivePath: "FO.zip!/L764_VERGHERETO.zip!/L764_VERGHERETO_ple.gml",
                        gmlMember: 7_015
                    },
                    canonicalContentHash: "7b05e29a2ef58f458c355d12bdaaeec45ce965e3c7c1f18a86a9325a98ef2687",
                    sourceGeometrySha256: "cc8ca555a71a55f6c0efef17877dc709c2d0c9dd8b2a3fe16b683a8609300948"
                }
            ]
        },
        {
            artifactKey: "ade-cadastre-rer-regional-bulk",
            layerKey: "CADASTRAL_PARCEL",
            externalIdSha256: "caf39b8e277afba6111924b61c696cd2a5957dc34df641504cdd4921d66ba3a7",
            logicalSourceSha256: "90b1d304530885986cb6716aead301deda26772f112f8a50e2321e4efea6cba6",
            cardinality: 2,
            unionGeometrySha256: "c99d398e281638c80df89d2b4e21c83acaff6c378f794c621f09300e8f69fc1a",
            overlapEvidence: {
                overlappingPairCount: 1,
                overlapArea: 6.393201567374707e-14,
                unionArea: 0.000010436028444466737,
                overlapRatio: 6.126086759340362e-9,
                maximumPairOverlapArea: 6.393195311257768e-14,
                maximumPairOverlapRatio: 0.0008558820938629954
            },
            occurrences: [
                {
                    locator: {
                        archivePath: "FO.zip!/L764_VERGHERETO.zip!/L764_VERGHERETO_ple.gml",
                        gmlMember: 1_218
                    },
                    canonicalContentHash: "934d9dcad22b380cd3c93781eeae07e925c0aee1bf11aab1daeeadc03401dc24",
                    sourceGeometrySha256: "d7457699939cea49858c0a1ce41317eaebcfa23d04a959c5d72bb580a289e8e0"
                },
                {
                    locator: {
                        archivePath: "FO.zip!/L764_VERGHERETO.zip!/L764_VERGHERETO_ple.gml",
                        gmlMember: 1_219
                    },
                    canonicalContentHash: "17d86d212ef757e55740f2756dc7f7b61bd7abbce450f7b1d2f8d38e6257d87d",
                    sourceGeometrySha256: "da1a31a666c21292c736f3a27cea460f631269cbbc62d3562562940332660109"
                }
            ]
        }
    ]
};
export const ADE_CADASTRE_MULTIPART_REPAIR_POLICY_V2 = {
    ...ADE_CADASTRE_MULTIPART_REPAIR_POLICY_V1,
    contractVersion: "ade-cadastre-multipart-repair-policy/v2",
    entries: [
        ADE_CADASTRE_MULTIPART_REPAIR_POLICY_V1.entries[0],
        {
            ...ADE_CADASTRE_MULTIPART_REPAIR_POLICY_V1.entries[1],
            overlapEvidence: {
                ...ADE_CADASTRE_MULTIPART_REPAIR_POLICY_V1.entries[1].overlapEvidence,
                maximumPairOverlapArea: 2.5690551441277176e-12,
                maximumPairOverlapRatio: 0.00004255195374662804
            }
        },
        ADE_CADASTRE_MULTIPART_REPAIR_POLICY_V1.entries[2],
        {
            ...ADE_CADASTRE_MULTIPART_REPAIR_POLICY_V1.entries[3],
            overlapEvidence: {
                ...ADE_CADASTRE_MULTIPART_REPAIR_POLICY_V1.entries[3].overlapEvidence,
                maximumPairOverlapArea: 4.3902354087712914e-14,
                maximumPairOverlapRatio: 0.0002756421623980759
            }
        },
        ADE_CADASTRE_MULTIPART_REPAIR_POLICY_V1.entries[4]
    ]
};
export const ADE_CADASTRE_MULTIPART_REPAIR_POLICY_V3 = {
    ...ADE_CADASTRE_MULTIPART_REPAIR_POLICY_V2,
    contractVersion: "ade-cadastre-multipart-repair-policy/v3",
    mappingVersion: "ade-cadastre/v4"
};
export const ADE_CADASTRE_MULTIPART_REPAIR_POLICY = ADE_CADASTRE_MULTIPART_REPAIR_POLICY_V3;
//# sourceMappingURL=ade-cadastre-multipart-repair-policy.js.map